// config.js
const ENV = process.env.REACT_APP_ENV;

const config = {
  development: {
    clientID: process.env.REACT_APP_WSO2_CLIENT_ID,
    baseUrl: process.env.REACT_APP_WSO2_BASE_URL,
    signInRedirectURL: process.env.REACT_APP_SIGN_IN_REDIRECT_URL,
    signOutRedirectURL: process.env.REACT_APP_SIGN_OUT_REDIRECT_URL,
    scope: ["openid", "buddyX", "profile", "roles"],
  },
  prodction: {
    clientID: process.env.REACT_APP_QA_WSO2_CLIENT_ID,
    baseUrl: process.env.REACT_APP_QA_WSO2_BASE_URL,
    signInRedirectURL: process.env.REACT_APP_QA_SIGN_IN_REDIRECT_URL,
    signOutRedirectURL: process.env.REACT_APP_QA_SIGN_OUT_REDIRECT_URL,
    scope: ["openid", "buddyX", "profile", "roles"],
  },
};

const wso2Config = config[ENV] || config.development;

export default wso2Config;
